export const QA_NAME_HEADER_SEPARATOR = 'HeaderSeparator'
